import type { CreateTableInput } from "../domain/table";
import {
  createTableAPI,
  deleteTableAPI,
  fetchOneTableAPI,
  fetchTableColumnTypesAPI,
  fetchTablesAPI,
  updateTableAPI,
} from "../infrastructure/table.api";
import type { APITable, TableColumnTypes } from "../infrastructure/table.formatter";

export async function createTable(referenceId: number, input: CreateTableInput): Promise<void> {
  await createTableAPI(referenceId, input);
}

export async function fetchTables(referenceId: number): Promise<APITable[]> {
  return await fetchTablesAPI(referenceId);
}

export async function updateTable(
  referenceId: number,
  tableId: number,
  input: CreateTableInput,
): Promise<void> {
  await updateTableAPI(referenceId, tableId, input);
}

export async function fetchOneTable(referenceId: number, tableId: number): Promise<APITable> {
  return await fetchOneTableAPI(referenceId, tableId);
}

export async function deleteTable(referenceId: number, tableId: number): Promise<void> {
  await deleteTableAPI(referenceId, tableId);
}

export async function fetchTableColumnTypes(): Promise<TableColumnTypes> {
  return await fetchTableColumnTypesAPI();
}
